module.exports = __webpack_public_path__ + "img/call_service_black.ec3691b3.png";